import * as React from 'react';
import { ResourceRelationsService } from '../../services/ResourceRelationsService';
import { IRolePerrmission } from '../RelationAccesses/AccessDomainModels';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextField, CircularProgress, Chip } from '@material-ui/core';
import { getSensitiveDataPermissions, InfoLabel, RolePermissionOption, SensitiveDataWarningDialog } from './RolePermissionControlCommon';

interface IProps {
	applicationId: number;
	take: number;
	value: IRolePerrmission[];
	onSelect: (value: IRolePerrmission[]) => void;
	placeholder: string;
	administrativeRoleText: string;
	sensitiveDataText: string;
}

export default function RolePermissionsMultiAutocomplete(props: IProps) {
	
	const [loading, setLoading] = React.useState(false);
	const [options, setOptions] = React.useState<IRolePerrmission[]>([]);
	const [inputValue, setInputValue] = React.useState('');

	const [selected, setSelected] = React.useState<IRolePerrmission[]>([]);
	
	React.useEffect(() => {
		setSelected(props.value);
	}, [props.value]);

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setInputValue(event.target.value);
	};

	const fetch = React.useMemo(
		() => {
			return (args, callback) => {
				var service = new ResourceRelationsService();
				service.getRolePermissions(props.applicationId, args.input, props.take, (data) => {
					callback(data.rolePermissions);
				});
			}
		},
		[]
	);

	React.useEffect(() => {
		let active = true;

		setLoading(true);
		fetch({ input: inputValue }, (results?: IRolePerrmission[]) => {
			if (active) {
				var items = results || [];
				setOptions(items);
			}
			setLoading(false);
		});

		return () => {
			active = false;
		};
	}, [inputValue, fetch]);

	function handleChangeSelected(roles: IRolePerrmission[]) {
		setSelected(roles);

		var warnings = getSensitiveDataPermissions(props.value, roles);
		if (warnings.length == 0) {
			props.onSelect(roles);
		}
	}

	function handleAccepted(roles: IRolePerrmission[]) {
		setSelected(roles);
		props.onSelect(roles);
	}

	return (<>
		<Autocomplete
			multiple
			fullWidth
			className="mi-lab-autocomplete-outlined"
			value={selected}
			onChange={(event, newValue) => {
				let nv = newValue as IRolePerrmission[];
				handleChangeSelected(nv);
			}}
			getOptionLabel={(option: IRolePerrmission) => option.name}
			options={options}
			loading={loading}
			filterOptions={x => x}

			autoComplete
			includeInputInList

			placeholder={props.placeholder}

			renderInput={params => (
				<TextField
					{...params}
					fullWidth
					variant="outlined"
					placeholder={props.placeholder}
					onChange={handleChange}
					InputProps={{
						...params.InputProps,
						autoComplete: 'disabled',

						endAdornment: (
							<React.Fragment>
								{loading ? <CircularProgress color="inherit" size={20} /> : null}
								{params.InputProps.endAdornment}
							</React.Fragment>
						),
					}}
				/>
			)}

			renderOption={(option: IRolePerrmission) => <RolePermissionOption
				data={option}
				administrativeRoleText={props.administrativeRoleText}
				sensitiveDataText={props.sensitiveDataText}
			/>}

			renderTags={(tagValue, getTagProps) => {
				return tagValue.map((option, index) => {
					return (<Chip
						{...getTagProps({ index })}
						label={<InfoLabel
							data={option}
							administrativeRoleText={props.administrativeRoleText}
							sensitiveDataText={props.sensitiveDataText}
						/>}
					/>)
				});
			}}

		/>
		<SensitiveDataWarningDialog showWarningModal={getSensitiveDataPermissions(props.value, selected)} onAccept={() => handleAccepted(selected)} onClose={() => handleAccepted(props.value)} />
	</>);
}

